<template >
 
    <div class="added-widgets">
      <div class="deadline-widgets" id="heightChange" :class="{'small' : (selectedHeight == 'small'), 'medium' : (selectedHeight == 'medium'),'large' : (selectedHeight == 'large') }">
        <div class="header">
            <div class="title">
                <h4>USCIS Notices</h4>
            </div>
            <VuePerfectScrollbar   ref="mainSidebarPs"  
                class="scroll-area--main-sidebar"
                :settings="settings"  
               
            >
            <div class="widget-filters" v-if="false">
                <button class="filter_btn" :class="{'active':selecetedTab=='ALL'}"  @click="changeTab('ALL')"><em>All</em><span > {{ allDocsStats }} </span></button>
                <button class="filter_btn" :class="{'active':selecetedTab=='PENDING'}"  @click="changeTab('PENDING')" ><em>In Process</em><span >{{ pendingDocsStats }} </span></button>
                <button class="filter_btn" :class="{'active':selecetedTab=='COMPLETED'}"  @click="changeTab('COMPLETED')"><em>Completed</em><span >{{ completeDocsStats }} </span></button>
                <button class="filter_btn" :class="{'active':selecetedTab=='Ignored'}"  @click="changeTab('Ignored')"><em>Duplicate</em><span >{{ ignoredDocsStats}} </span></button>
                <button class="filter_btn" :class="{'active':selecetedTab=='Failed'}"  @click="changeTab('Failed')"><em>Failed</em><span >{{ failedDocsStats }} </span></button>
            </div>
            </VuePerfectScrollbar>
            <div class="actions">
            <ul>
              
            <li  @click="refreshList">
              <div class="IB_tooltip placement-down"  >
                    <figure :class="reloadClass"><img src="@/assets/images/reload.svg"  width="18" height="18"/></figure>
                    <div class="tooltip_cnt w-auto text-center">
                      <p>Refresh</p>
                    </div>
                  </div>
              </li>
            <li @click="togleExpend()"><figure class="maximize-img"><img src="@/assets/images/maximize.png"  width="18" height="18"/></figure><figure class="minimize-img"><img src="@/assets/images/minimize.png"  width="20" height="20"/></figure></li>
           </ul>
           </div>
            
          </div>      
        <VuePerfectScrollbar  
          ref="mainSidebarPs"
          class="scroll-area--main-sidebar"
          :settings="settings"  
          @ps-scroll-y="psSectionScroll"  
        >
        <div class="form-container">
            <div class="vx-row mar0">
              <div class="vx-col w-full">
                <div class="form_group pt-4"  @click=" documents = []" >
                  <div class="vs-component relative">                  
                    <file-upload
                      :multiple="true"
                      :hideSelected="true"
                      v-model="documents"
                      class="file-upload-input file_upload justify-center mb-0"
                      name="documentsUpload"
                      :accept="allDocEntity"
                      @updateData="updateData" >
                      <img
                        class="file-icon"
                        src="@/assets/images/main/file-upload.svg"
                      />
                      Upload
                    </file-upload>
                  <span class="file-type d-block text-center mb-0">(Note: Upload Receipt, Approval and RFE notices only)</span>
                  </div>
                  <ul
                    class="uploaded-list note_uploads mt-0"
                    v-if="checkProperty(selectedFiles, 'length') > 0"
                  >
                    <template v-for="(file, fileindex) in selectedFiles">
                      <vs-chip
                        type="button"
                        @click="removeFiles(fileindex)"
                        :key="fileindex"
                        v-if="file.status !== false"
                        closable
                        >{{ file.name }}
                      </vs-chip>
                    </template>
                  </ul>
                </div>
              </div>
            </div>
            <div class="popup-footer popup-footerv2 relative padr20">
                <vs-button  color="success"  :disabled=" checkProperty(selectedFiles, 'length')<=0"  @click="submitForm()"
                class="save" type="filled"  >Submit </vs-button>
            </div>
            <!-- <button :disabled="checkProperty(selectedFiles, 'length')<=0" @click="submitForm">Submit</button> -->
         
          </div>
          <template  v-if="checkProperty(documentsList ,'length')>0 && !isListLoading ">
            <div class="missed-deadlines" v-if="checkProperty(documentsList ,'length')>0">
                <div class="widget-content uploaded_files_widget">
                    <div class="widget-deadline-list" v-for="(docItem ,itmIndex) in documentsList" :key="itmIndex">
                        <div class="deadline-details justify-content-between ai-widget">
                            <!-- <docmentType :title="checkProperty(item, 'document', 'name')" :item="item['document']" /> -->
                            <!-- <div class="missed-date cursor" @click="download_or_view(checkProperty(item, 'document'))" >
                                <docmentType :title="checkProperty(item, 'name')" :item="item['name']" />
                            </div> -->
                            <!-- <div class="missed-date cursor" @click="download_or_view(checkProperty(item))" >
                                <docmentType :title="checkProperty(item,  'name')" :item="item['name']" />
                            </div> -->
                            <div class="deadline-info deadline-info-updates ">
                                <template>
                                  <div class="filters_styling">
                                    <p v-if="checkProperty(docItem,  'nameNo')"> {{checkProperty(docItem,'nameNo')}} </p> 
                                    <ul class="widget-filters">
                                      <li class="filter_btn all">
                                            <em>All</em><span>{{totalDocumentCount(docItem)}}
                                            </span>
                                        </li>
                                      <li class="filter_btn pending">
                                            <em>In Process</em><span>{{checkProperty( docItem,'pending')}}
                                            </span>
                                        </li>
                                        <li class="filter_btn completed">
                                            <em>Completed</em><span>{{checkProperty( docItem,'completed')}}
                                            </span>
                                        </li>
                                        <li class="filter_btn ignored">
                                            <em>Duplicate</em><span>{{checkProperty( docItem,'ignored')?checkProperty( docItem,'ignored'):0}}
                                            </span>
                                        </li>
                                        <li class="filter_btn casenotfound">
                                            <em>Case Not Found</em><span>{{checkProperty( docItem,'caseNotFound')?checkProperty( docItem,'caseNotFound'):0}}
                                            </span>
                                        </li>
                                        <li class="filter_btn failed">
                                            <em>Failed</em><span>{{checkProperty( docItem,'failed')?checkProperty( docItem,'failed'):0}}
                                            </span>
                                        </li>
                                        
                                    </ul>

                                  </div>
                                    <ul>
                                        <li v-if="checkProperty( docItem,'createdByName')" class="cursor-default">
                                            <span > By {{checkProperty( docItem,'createdByName')}}
                                              <template >({{checkProperty( docItem,'createdByRoleName')}}) On {{checkProperty( docItem,'createdOn')| formatDateTime}}</template> </span>
                                        </li>
                                        <!-- <li v-if="checkProperty( docItem,'createdOn')">
                                            <span>Created On:
                                            <template >{{checkProperty( docItem,'createdOn')| formatDateTime}}</template>
                                            </span>
                                        </li> -->
                                    </ul> 
                                </template>
                            </div>
                              <div class="ai_actions">
                                <div class="ai_status" v-if="(checkProperty( docItem,'docsProcessing')==true||checkProperty( docItem,'docsProcessing')=='true'||checkProperty( docItem,'docsReading')==true||checkProperty( docItem,'docsReading')=='true')">
                                  <span class="status_icon reading" v-if="(checkProperty( docItem,'docsReading')==true||checkProperty( docItem,'docsReading')=='true')">   
                                   <div class="pulsating-circle"></div>
                                    Reading
                                  </span>
                                  <span class="status_icon processing" v-if="(checkProperty( docItem,'docsProcessing')==true||checkProperty( docItem,'docsProcessing')=='true')">   
                                    <div class="circle"></div>                                  
                                    Processing
                                  </span>
                                </div>
                                <span  v-if="(checkProperty( docItem,'docsProcessing')==false||checkProperty( docItem,'docsProcessing')=='false')" @click="showDetails(docItem)" class="offcanvas-btn">Details</span>
                                
                              </div>
                              
                            
                        </div>
                    </div>  
                </div>
<div class="table_footer footer-padding">
 
  <!-- v-if="isPageNation&&documentsList.length > 0" -->
  <!-- <button v-if="!isPageNation&&totalCount>perpage" class="filter_btn" :class="{'active':true}"  @click="togleExpend()"><em>View All</em></button> -->
<div class="vx-col  con-select pages_select" v-if="documentsList.length > 0">
  <label class="typo__label">Per Page</label>
  <multiselect  @input="changeperPage()" v-model="perpage" :options="perPeges" :multiple="false"
    :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Per Page"
    :preselect-first="true" :allow-empty="false">
 
  </multiselect>
  <span class="totla_list_count" v-if="totalCount">Total <em>{{ totalCount }}</em></span>
</div>
<!-- v-if="isPageNation&&documentsList.length > 0&&totalCount>perpage" -->
<paginate v-if="documentsList.length > 0" v-model="page" :page-count="totalpages" :page-range="3"
  :margin-pages="2" :click-handler="pageNate"
  prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
  next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" :prev-text="'<i></i>'"
  :next-text="'<i></i>'" :container-class="'pagination vs-pagination--nav'" :page-class="'page-item'">
</paginate>
</div>
            </div>
          </template>
          <template v-else>
          <div class="widget-content">
           <NoDataFound
              ref="NoDataFoundRef"
              :loading="isListLoading"
              heading="No Data"
              type="support"
              />
          </div>
 
 
               
                 
                </template>
        </VuePerfectScrollbar>
      </div>
     
 
 
      <vs-popup
      class="document_modal document_modal-v2 "
      :class="{ 'expand': expandModal, 'custom_close_doc_modal':showCloseIcon }"
      :title="checkProperty(selectedFile, 'name')"
      :active.sync="docPrivew"
    >
    <div class="document_actions" @click="expandModal = !expandModal">
      <figure v-if="!expandModal" class="maximize-img"><img src="@/assets/images/maximize.png"  width="18" height="18"/></figure>
      <figure v-else class="minimize-img"><img src="@/assets/images/minimize.png"  width="20" height="20"/></figure>
    </div>
    <div class="custom_close" v-if="showCloseIcon">
      <figure class="close_icon" @click="showConfrmLetterPopup = true;updateletterLoading = false;errorMessage=''">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 20 20"><path class="a" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm4.3,12.708L12.705,14.3A36.72,36.72,0,0,0,10,11.6a37.242,37.242,0,0,0-2.706,2.7L5.7,12.708A31.208,31.208,0,0,0,8.4,10,30.784,30.784,0,0,0,5.7,7.3L7.292,5.7s2.541,2.7,2.706,2.7,2.708-2.7,2.708-2.7L14.3,7.3A36.62,36.62,0,0,0,11.591,10C11.591,10.183,14.3,12.708,14.3,12.708Z"/></svg>
      </figure>
    </div>
      <h2>
        <img
          :class="{
            pdf_view_download: docType == 'pdf',
            office_view_download: docType == 'office',
            image_view_download: docType == 'image',
          }"
          class="download-button"
          @click="downloads3file(selectedFile)"
          src="@/assets/images/download.svg"
        />
      </h2>
      <div class="pdf_loader">
        <figure v-if="formSubmited && !saveEditedFile" class="loader loader2">
          <img src="@/assets/images/main/loader.gif" />
        </figure>
        <template v-if="docType == 'office'">
          <div style="height: 90vh">
            <div id="placeholder" style="height: 100%"></div>
          </div>
        </template>
        <template v-else-if="docType == 'image'">
          <img :src="docValue" />
        </template>
        <template v-else-if="docType == 'pdf'">
          <div class="pdf" style="height: 90vh">
            <iframe
              v-if="docValue != ''"
              border="0"
              style="border: 0px"
              :src="docValue"
              height="100%"
              width="100%"
            >
            </iframe>
          </div>
        </template>
      </div>
    </vs-popup>
       
    <DocumentTools v-if="showToolsPopup" @handleClose="handleClose" />
    </div>
  </template>
   
   
  <script>
   import VuePerfectScrollbar from "vue-perfect-scrollbar";
   import Multiselect from "vue-multiselect-inv";
   import { MoreHorizontalIcon } from 'vue-feather-icons'
  import NoDataFound from "@/views/common/noData.vue";
  import moment from "moment";
  //import widgetHeader from "./widgetHeader.vue";
  import docmentType from "@/views/common/docType.vue";
  import DocumentTools from "../common/documentToolsPopup.vue";
  import FileUpload from "@/views/FileUpload.vue";
  import Paginate from "vuejs-paginate";
    export default {
      components: {
        NoDataFound,
        VuePerfectScrollbar,
        Multiselect,
        MoreHorizontalIcon,
        docmentType,
        DocumentTools,
        FileUpload,
        //widgetHeader
        Paginate
      },
      data: function () {
        return {
          reloadClass:"",
            selecetedTab:'ALL',
            allDocsStats:0,
            pendingDocsStats:0,
            completeDocsStats:0,
            ignoredDocsStats:0,failedDocsStats:0,
            selectedFiles:[],
            documents:[],
        showToolsPopup:false,
        groupedlist:[],  
        todayCaseList: [],
        tomorrowCaseList : [],
        missedDeadLineCaseList : [],
 
          popupFilter:false,
          value: null,
          options: [],
          primary:'',
 
 
          selectedHeight:'small',
           isListLoading:true,
          widgetsItems:null,
          settings: {
            swipeEasing: false,
          },
          duplicating:false,
          widGetCode:'DEADLINE',
          documentsList:[],
          selectedItem:null,
            callFromEdit:null,
            selectedFileForEdit:false,
            showCloseIcon:false,
            expandModal:false,
            formSubmited:false,
            docValue: "",
            docType: "",
            selectedFile:null,
            docPrivew:false,
            perPeges: [10,25, 50, 75, 100],
            totalpages: 0,
            totalCount: 0,
            perpage: 10,
            page: 1,
            isPageNation:false
        };
       
      },
      props: {
         listForDashboard:null,
        availableEmptyColumns:0,
        rowExistingColumnsLength:0,
        columnId:'',
        rowId:'',
      widgetData:null,
       wedgetHights:{
         
          "1X":'small',
          "1.5":"medium",
          "2X":"large"
        },
        tabName:'CASES',
        selectedBranch:null,
        dueDatekey:'deadlineDate'
 
     },
      methods:{
        parseProperty(item, property) {
          let value = this.checkProperty(item, property);
          return isNaN(parseInt(value)) ? 0 : parseInt(value);
        },
        totalDocumentCount(docItem) {
          return (
            this.parseProperty(docItem, 'pending') +
            this.parseProperty(docItem, 'completed') +
            this.parseProperty(docItem, 'ignored') +
            this.parseProperty(docItem, 'caseNotFound') +
            this.parseProperty(docItem, 'failed')
          );
        },
    refreshList(){
      this.reloadClass='reload_loading'
      // let payLoad={}
      // this.$store.dispatch("commonAction", {"data":payLoad ,"path":"ai-tools/process-pending-requests"}).then((response)=>{
      // }).catch((error)=>{
      // })
      this.getDocumentsList();
    },
        showDetails(docItem){
          this.$emit('show-details', docItem)
          ///console.log("emitttt",docItem)
        },
        changeperPage() {
      this.page = 1;
      localStorage.setItem('petitions_perpage', this.perpage);
      this.getDocumentsList(this.selecetedTab);
    },
    pageNate(pageNum,perpage=10) {
 
this.page = pageNum;
//this.perpage=perpage
this.getDocumentsList();
},
        togleExpend(data){
          this.isPageNation=!this.isPageNation
          if(!this.isPageNation){
            this.perpage=10
           // this.pageNate(1,10)
           this.changeTab('ALL')
          }
          this.$emit('togleExpend',{"columnId":1})
        },
        changeTab(tab ='ALL'){
            this.page = 1;
            this.selecetedTab = tab;
            this.getCount(tab);
            this.getDocumentsList(tab);
        },
        removeFiles(index){
            let item=this.selectedFiles[index]
            this.selectedFiles.splice(index ,1)
            this.removeFileFromS3(item)
        },
        submitForm() {
            let postData={
              "items": [{
              "category": "uscis_notice",
              "documents":this.selectedFiles
              }]
            }
            this.$store.dispatch("commonAction", {"data":postData ,"path":"/ai-tools/create-request"}).then((response)=>{
              this.selectedFiles = [];
              this.documents = [];
              this.changeTab('ALL')
            //   this.getDocumentsList();
            //   this.getCount();
            }).catch((error)=>{
 
            })              
        },
        updateData(docs){
            this.selectedFiles = docs;
        },
        showTools(){
            this.showToolsPopup=true
        },
        handleClose(success = false){
            this.showToolsPopup=false;    
        },
        getCount(tab = 'ALL'){
            let payLoad={
                "filters": {
                    title:'',
                    categoryList:['uscis_notice'],
                    statusIdList:[]
                },  
            };
            let path='/ai-tools/cron-request-stats'
            this.$store.dispatch("getList", { "data": payLoad, "path": path }).then((response)=>{
                if(response && response.length>0){
                    let findPenObj = _.find(response, {'statusId':1})
                    if(findPenObj && findPenObj['count'] ){
                        this.pendingDocsStats = findPenObj['count']
                    }
                    let findcomObj = _.find(response, {'statusId':2})
                    if(findcomObj && findcomObj['count'] ){
                        this.completeDocsStats = findcomObj['count']
                    }
                    let findignObj = _.find(response, {'statusId':3})
                    if(findignObj && findignObj['count'] ){
                        this.ignoredDocsStats = findignObj['count']
                    }
                    let findfaildObj = _.find(response, {'statusId':4})
                    if(findfaildObj && findfaildObj['count'] ){
                        this.failedDocsStats = findfaildObj['count']
                    }
                    // if(tab == 'PENDING'){
                       
                    //     console.log(this.pendingDocsStats)
                    // }
                    // if(tab == 'COMPLETED'){
                       
                    // }
                    if(this.completeDocsStats > 0 || this.pendingDocsStats > 0||this.ignoredDocsStats > 0||this.failedDocsStats > 0  ){
                        this.allDocsStats = parseInt(this.completeDocsStats) + parseInt(this.pendingDocsStats)+ parseInt(this.ignoredDocsStats)+ parseInt(this.failedDocsStats)
                    }
                }
            }).catch((err)=>{
 
            })
        },
 
 
       
        psSectionScroll(event){
 
        },
        getDocumentsList(tab = 'ALL'){
            let payLoad={
                "filters": {
                    title:'',
                    categoryList:['uscis_notice'],
                    statusIdList:[]
                },  
                "page": this.page,
                "perpage": this.perpage
            };
            if(tab == 'PENDING'){
                payLoad['filters']['statusIdList'] = [1]
            }
            if(tab == 'COMPLETED'){
                payLoad['filters']['statusIdList'] = [2]
            }
            if(tab == 'Ignored'){
              payLoad['filters']['statusIdList'] = [3]
            }
            if(tab == 'Failed'){
              payLoad['filters']['statusIdList'] = [4]
            }
            this.documentsList = [];
            this.isListLoading = true;
            this.updateLoading(true);
            //let path='/ai-tools/cron-request-list'
           let path='/ai-tools/request-list'
            this.$store.dispatch("getList", { "data": payLoad, "path": path }).then((response)=>{
                this.isListLoading = false;
                this.updateLoading(false);
                this.reloadClass=''
                this.totalCount = this.checkProperty(response, 'totalCount')
                this.totalpages = Math.ceil(response.totalCount / this.perpage);
                setTimeout(()=>{
                    this.updateLoading(false);
                },5)
                if(_.has(response, 'list') && response.list){
                    this.documentsList = response.list;
                   
                }
            }).catch((err)=>{
              this.reloadClass=''
            })
        },
        download_or_view(docItem) {
      let value = _.cloneDeep(docItem);
      this.selectedFileForEdit =false;
      this.showCloseIcon = false;
      if ( _.has(value ,'viewmode') && this.checkProperty(value,'viewmode')==false ) {
          this.selectedFileForEdit =true;
      }
 
      this.expandModal= false;
 
      if (
        this.checkProperty(this.getPetitionDetails, "caseNo") &&
        this.checkProperty(value, "name")
      ) {
        let docName = _.cloneDeep(value["name"]);
       
        try{
          if(!docName.includes(this.checkProperty(this.getPetitionDetails, "caseNo"))){
            value["name"] = docName;
          }
        }catch(err){
 
        }
 
       
      }
 
      var _self = this;
      this.formSubmited = false;
      if (_.has(value, "path")) {
        value["url"] = value["path"];
        value["document"] = value["path"];
      }
 
      if (_.has(value, "url")) {
        value["path"] = value["url"];
        value["document"] = value["url"];
      }
 
      if (_.has(value, "document")) {
        value["path"] = value["document"];
        value["url"] = value["document"];
      }
 
      this.selectedFile = value;
      this.docValue = "";
      this.docPrivew = false;
      this.docType = false;
      this.docType = this.findmsDoctype(value);
      this.showCloseIcon = false;
 
      //if ( (this.docType == "office" || this.docType == "image" || this.docType == "pdf") && value.download == false ) {
      if (this.docType == "office" || this.docType == "image" || this.docType == "pdf") {
        value.url = value.url.replace(this.$globalgonfig._S3URL, "");
        value.url = value.url.replace(this.$globalgonfig._S3URLAWS, "");
        let postdata = {
          keyName: value.url,
          petitionId: value["petitionId"],
        };
        this.$store.dispatch("getSignedUrl", postdata).then((response) => {
          this.docValue = response.data.result.data;
 
          if (this.docType == "office") {
            document.getElementById("placeholder").innerHTML =
              "  <div  id='placeholder2' style='height:100%'></div>";
            let _editing = false;
 
            if ([50, 51].indexOf(this.getUserRoleId) > -1) {
              _editing = false;
            }
           
            let docViewUrl ='https://immibox.com/api/petition/post-edited-document';
            if(_.has(this.$globalgonfig, 'DOC_VIEW_URL')){
              docViewUrl = this.$globalgonfig['DOC_VIEW_URL'];
            }
 
            let entityId = 'cover_letter';
            if(this.checkProperty(value,'entityId')){
              entityId = value['entityId'];
            }
               
            if ( _.has(value ,'viewmode') && value.viewmode==false ) {
              _editing = true;
              if(_.has(value,'type') && _self.checkProperty(value, 'type') == 'Letter' && _.has(value,'generated') &&
              (_self.checkProperty(value, 'generated') == true || _self.checkProperty(value, 'generated') == 'true') && !value['parentId']
               ){
                this.showCloseIcon = true;
                // && this.checkProperty( this.$store.state ,'selectedForEditDocument') && this.checkProperty( this.$store.state ,'selectedForEditDocument', 'savedDocumentId')
              }
            }
            var _ob = {};
            if (value.editedDocument) {
              _ob = {
               // entityId:entityId,
                petitionId: this.petition._id,
                name: value.name,
                _id: value._id,
                extn: "docx",
                formLetterType: "Letter",
                parentId: value.parentId,
              };
            } else {
              _ob = {
               // entityId:entityId,
                name: value.name,
                petitionId: this.petition._id,
                _id: value._id,
                extn: "docx",
                formLetterType: "Letter",
                parentId: value._id,
              };
            }
            var nid = value._id +  Math.round(+new Date()/1000)
            window.docEditor = new DocsAPI.DocEditor("placeholder2", {
              document: {
                c: "forcesave",
                fileType: "docx",
                key: nid,
                userdata: JSON.stringify(_ob),
                title: value.name,
                url: response.data.result.data,
                permissions: {
                  edit: _editing,
                  download: true,
                  reader: false,
                  review: false,
                  comment: false,
                },
              },
 
              documentType: "word",
              height: "100%",
              width: "100%",
 
              editorConfig: {
                userdata: JSON.stringify(_ob),
                callbackUrl:
                docViewUrl+"?entityId="+entityId+"&payload=" +
                  JSON.stringify(_ob) +
                  "&token=" +
                  _self.$store.state.token +
                  "&name=" +
                  value.name.replace(".docx", ""),
                customization: {
                  logo: {
                    image: "https://immibox.com/app/favicon.png",
                    imageDark: "https://immibox.com/app/favicon.png",
                    url: "https://immibox.com",
                  },
                  anonymous: {
                    request: false,
                    label: "Guest",
                  },
                  chat: false,
                  comments: false,
                  compactHeader: false,
                  compactToolbar: true,
                  compatibleFeatures: false,
                  feedback: {
                    visible: false,
                  },
                  forcesave: true,
                  help: false,
                  hideNotes: true,
                  hideRightMenu: true,
                  hideRulers: true,
                  layout: {
                    toolbar: {
                      collaboration: false,
                    },
                  },
                  macros: false,
                  macrosMode: "warn",
                  mentionShare: false,
                  plugins: false,
                  spellcheck: false,
                  toolbarHideFileName: true,
                  toolbarNoTabs: true,
                  uiTheme: "theme-light",
                  unit: "cm",
                  zoom: 100,
                },
              },
              events: {
                onReady: function () {},
                onDocumentStateChange: function (event) {
                  var url = event.data;
                  if (!event.data) {
                    if (value.editedDocument) {
                    }
                  }
                },
              },
            });
            //this.docValue = encodeURIComponent(response.data.result.data);
          }
 
          if (this.docType == "pdf") {
            var formAndLetterId = value._id;
            let parentId = '';
            // if (this.checkProperty(value,'parentId')) {
            //   parentId = value.parentId;
            // }else{
            //   if (this.checkProperty(value,'generated')) {
            //     parentId = value._id;
            //   }
             
            // }
            //alert(parentId)
            var  viewmode = 0; //viewmode= 1 Enable edit AND viewmode= 0; //Disabled Edit
            let pdfViewUrl ='https://immibox.com/viewer/pdfjs-dist/web/viewerv2.html';
           
            if(_.has(this.$globalgonfig, 'PDF_VIEW_URL')){
              pdfViewUrl = this.$globalgonfig['PDF_VIEW_URL'];
            }
             
 
            if(_.has(value ,'viewmode')){
              if (value.viewmode) {
                viewmode = 0;
              }else{
                viewmode = 1;
                viewmode=viewmode+"&depLabel="+value.depLabel+"&depType="+value.depType+"&docUserType="+value.docUserType+"&generated="+value.generated+"&parentId="+parentId+"&formAndLetterId="+formAndLetterId+"&save=v2&docname="+value.name+"&posturl="+this.$globalgonfig._APIURL+"/&petitionId="+this.$route.params.itemId+"&entityId="+value.entityId+"&token="+this.$store.state.token
                if(_.has(this.$globalgonfig, 'PDF_EDIT_URL')){
                  pdfViewUrl = this.$globalgonfig['PDF_EDIT_URL'];
                 
                 }
              }
 
            }
 
           
           
           
            if(this.getPetitionTab != 'Forms and Letters'){
              viewmode= 0; //Disabled Edit
              if(_.has(this.$globalgonfig, 'PDF_VIEW_URL')){
                pdfViewUrl = this.$globalgonfig['PDF_VIEW_URL'];
              }
             
            }
           
            this.docValue =
            pdfViewUrl+"?view=" +
              viewmode +
              "+&file=" +
              encodeURIComponent(response.data.result.data);
          }
          this.docPrivew = true;
        });
      } else {
        this.downloads3file(value);
      }
    },
 
     
    },
     mounted() {
        this.getDocumentsList();
        setTimeout(()=>{
            this.getCount();
        })
        // this.getCount('COMPLETED');
        // this.getCount('PENDING');
     }
 
   
 
   
   
   
  };
  </script>